var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50012 1L17.5001 15",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2568 12.2567C18.6353 11.2577 19.8827 9.92844 20.9182 8.27445C20.9718 8.19269 21.0001 8.09693 21.0001 7.9999C21.0002 7.93034 20.9857 7.86011 20.9557 7.79391C20.945 7.77032 20.9325 7.74748 20.9182 7.72564C18.3366 3.59957 14.4365 1.50012 10.5014 1.5C9.33675 1.49996 8.17513 1.6838 7.04977 2.04965L7.85378 2.85366C8.72599 2.61748 9.61476 2.49997 10.5013 2.5C13.9812 2.50011 17.4938 4.31099 19.9066 7.99992C18.9365 9.48235 17.7892 10.6605 16.5399 11.5398L17.2568 12.2567ZM8.27525 5.27513L13.225 10.2249L12.975 10.4749C11.6082 11.8417 9.39208 11.8417 8.02525 10.4749C6.65841 9.10804 6.65841 6.89196 8.02525 5.52513L8.27525 5.27513ZM6.37606 3.37594C4.38295 4.25202 2.54078 5.78852 1.09351 8.00008C4.58913 13.3448 10.3997 14.7636 15.1265 12.3876C15.1842 12.3586 15.2417 12.3291 15.2991 12.2989L16.0367 13.0365C15.8842 13.1217 15.7305 13.2033 15.5756 13.2811C10.275 15.9455 3.80833 14.2301 0.0819463 8.2744C0.068033 8.25317 0.0558249 8.231 0.0453733 8.20811C-0.0135985 8.07895 -0.0166498 7.92686 0.0454271 7.79177C0.0558781 7.7689 0.0680838 7.74674 0.0819919 7.72553C1.57229 5.34501 3.50108 3.63918 5.62198 2.62186L6.37606 3.37594ZM8.41416 6.62115C7.77106 7.59183 7.87712 8.91254 8.73236 9.76777C9.58759 10.623 10.9083 10.7291 11.879 10.086L8.41416 6.62115Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.84b4e5c8ad846004a983f96b53d63b39.svg";
export { ForwardRef as ReactComponent };